module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-GB":{"order-files":"Order Files","no-files":"No files","failed-retrieve-files":"Failed to retrieve files","failed-upload-files":"Failed to upload files","failed-delete-file":"Failed to delete file","file-deleted":"File deleted","delete-file":"Delete File"}}')
  delete Component.options._Ctor
}
